import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import './fonts/Roboto-Black-900.ttf';
import './fonts/Roboto-Bold-700.ttf';
import './fonts/Roboto-Regular-400.ttf';
//Importar bootstrap
import 'bootstrap/dist/css/bootstrap.min.css'
import AppRoutes from './routes';
import reactGa4 from 'react-ga4';

reactGa4.initialize('G-RJZX1BQ8GV')
reactGa4.send('pageview')

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter forceRefresh={true}>
      <AppRoutes />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
